// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1TGpI","gfeWrapper":"CalendarEvent_gfeWrapper__zNGxj"};